import {
  EXECUTE_AURORA_SQL_REQUEST,
  EXECUTE_AURORA_SQL_SUCCESS,
  EXECUTE_AURORA_SQL_FAILURE,
  GET_QUERY_BUILDER_SCHEMA_REQUEST,
  GET_QUERY_BUILDER_SCHEMA_SUCCESS,
  GET_QUERY_BUILDER_SCHEMA_FAILURE,
} from "../actions/auroraSqlActions";

const initialState = {
  // Execute Aurora SQL
  executeLoading: false,
  executeData: null,
  executeError: null,

  // Get Query Builder Schema
  schemaLoading: false,
  schemaData: null,
  schemaError: null,
};

const auroraSqlReducer = (state = initialState, action) => {
  switch (action.type) {
    // Execute Aurora SQL
    case EXECUTE_AURORA_SQL_REQUEST:
      return {
        ...state,
        executeLoading: true,
        executeError: null,
      };
    case EXECUTE_AURORA_SQL_SUCCESS:
      return {
        ...state,
        executeLoading: false,
        executeData: action.payload,
        executeError: null,
      };
    case EXECUTE_AURORA_SQL_FAILURE:
      return {
        ...state,
        executeLoading: false,
        executeError: action.payload,
      };

    // Get Query Builder Schema
    case GET_QUERY_BUILDER_SCHEMA_REQUEST:
      return {
        ...state,
        schemaLoading: true,
        schemaError: null,
      };
    case GET_QUERY_BUILDER_SCHEMA_SUCCESS:
      return {
        ...state,
        schemaLoading: false,
        schemaData: action.payload,
        schemaError: null,
      };
    case GET_QUERY_BUILDER_SCHEMA_FAILURE:
      return {
        ...state,
        schemaLoading: false,
        schemaError: action.payload,
      };

    default:
      return state;
  }
};

export default auroraSqlReducer;
